import { company, products } from '../content';
import { endpoints } from '../config';

/** §4.1 Company: about SJS Tech, contact, partners and careers. */
export default function Company() {
  const available = products.filter((product) => product.availability === 'available');
  const planned = products.filter((product) => product.availability === 'planned');

  return (
    <>
      <section className="section">
        <div className="wrap">
          <div className="section__head">
            <span className="eyebrow">Company</span>
            <h1 style={{ marginBottom: 16 }}>SJS Tech</h1>
            <p>{company.tagline}</p>
          </div>

          <div className="grid grid--2" style={{ gap: 48, alignItems: 'start' }}>
            <div>
              <h2 style={{ fontSize: '1.4rem' }}>About</h2>
              <p style={{ color: 'var(--muted)' }}>{company.about}</p>

              <div className="table-wrap" style={{ marginTop: 24 }}>
                <table style={{ minWidth: 0 }}>
                  <tbody>
                    <tr>
                      <th style={{ width: 150 }}>Provider</th>
                      <td>SJS Tech</td>
                    </tr>
                    <tr>
                      <th>Product</th>
                      <td>ClientMa</td>
                    </tr>
                    {/*
                      Derived from the product list rather than typed here. This table said
                      "Available now: ClientMa CRM" and "Planned: SRM, Inventory and the modular
                      HR suite" long after two of those three had shipped — which is what a
                      hand-kept copy of a fact does, and why this one is not kept by hand.
                    */}
                    <tr>
                      <th>Available now</th>
                      <td>{available.map((p) => p.name).join(', ')}</td>
                    </tr>
                    {planned.length > 0 && (
                      <tr>
                        <th>Planned</th>
                        <td>{planned.map((p) => p.name).join(', ')}</td>
                      </tr>
                    )}
                    <tr>
                      <th>Regions</th>
                      <td>{company.regions}</td>
                    </tr>
                    <tr>
                      <th>Built with</th>
                      <td>{company.stack}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <h2 style={{ fontSize: '1.4rem' }}>Contact</h2>
              <p style={{ color: 'var(--muted)' }}>
                Tell us the size of your team, the country you operate in and what you are running
                today. We will come back with pricing and a migration outline rather than a
                brochure.
              </p>

              <div className="card" style={{ marginTop: 20 }}>
                <h3>Sales</h3>
                <p style={{ marginBottom: 14 }}>
                  Pricing, plan comparison, bundles and negotiated terms.
                </p>
                <a className="btn btn--primary" href="mailto:sales@sjstech.example">
                  sales@sjstech.example
                </a>
              </div>

              <div className="card" style={{ marginTop: 16 }}>
                <h3>Support</h3>
                <p style={{ marginBottom: 14 }}>
                  Existing customers reach support from inside the application, where a ticket
                  carries the context of what you were doing.
                </p>
                <a className="btn btn--ghost" href={endpoints.signIn}>
                  Sign in to raise a ticket
                </a>
              </div>

              <div className="card" style={{ marginTop: 16 }}>
                <h3>Partners</h3>
                <p style={{ marginBottom: 14 }}>
                  Implementation and reseller partners across India, Singapore and Malaysia.
                </p>
                <a className="btn btn--ghost" href="mailto:partners@sjstech.example">
                  partners@sjstech.example
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--sunken">
        <div className="wrap">
          <div className="band">
            <h2>Careers</h2>
            <p>
              We build one platform carefully rather than many things quickly. If that sounds like
              how you work, we would like to hear from you.
            </p>
            <div className="band__actions">
              <a className="btn btn--onDark btn--lg" href="mailto:careers@sjstech.example">
                careers@sjstech.example
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
